import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../hooks/redux';
import { clearOverageError } from '../../store/slices/overageSlice';

import happyBot from '../../assets/img/happy-bot.png';

interface OverageApprovalResultModalProps {
  isVisible: boolean;
  onClose: () => void;
  result: 'success' | 'error' | null;
}

const OverageApprovalResultModal: React.FC<OverageApprovalResultModalProps> = ({
  isVisible,
  onClose,
  result,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  if (!isVisible || !result) {
    return null;
  }

  const handleClose = () => {
    dispatch(clearOverageError());
    onClose();
  };

  const isSuccess = result === 'success';
  const title = isSuccess 
    ? t('overage.approval_result_success_title') 
    : t('overage.approval_result_error_title');

  return (
    <div className="modal-overlay">
      <div className="modal-content overage-approval-result-modal">
        <div className="modal-header">
        </div>
        
        <div className="modal-body">
          <div className="overage-approval-result__icon">
            <img src={happyBot} alt="happy-bot" />
          </div>
          <h2 className="overage-approval-result__title">
            {title}
          </h2>
          <p className="overage-approval-result__description">
            {t('overage.approval_result_success_message')}
          </p>
        </div>
        <div className="modal-footer">
          <button 
            className="overage-approval-result__close-btn"
            onClick={handleClose}
          >
            {t('overage.approval_result_go_to_dashboard')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OverageApprovalResultModal;
